import React from "react";
import "./index.css";
import ReactPlayer from "react-player";

export default function VideoPlayer(props) {
  const { onClose, currentIndex, videos, onChangeIndex, desc } = props;
  return (
    <div className="overlay">
      <div className="close-btn" onClick={onClose}>
        <span className="bi bi-x"></span>
      </div>
      <div className="text">
        <div className="player-container">
          <div className={`player-btns ${currentIndex - 1 < 0 ? "player-btns-visibility" : ""}`} onClick={() => onChangeIndex(currentIndex - 1)}>
            <span className="bi bi-arrow-left-circle-fill"></span>
          </div>

          <ReactPlayer className="video-player" playing controls={true} url={videos[currentIndex]} />

          <div className={`player-btns ${currentIndex + 2 > videos.length ? "player-btns-visibility" : ""}`} onClick={() => onChangeIndex(currentIndex + 1)}>
            <span className="bi bi-arrow-right-circle-fill"></span>
          </div>
        </div>
      </div>
      <div className="video-desc">{desc}</div>
    </div>
  );
}
